import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ITemplatePanelButtonProps } from './types';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TEMPLATE_SECTION_TITLE } from '../TemplateSection/constants';

export function TemplatePanelButton ({
    isShow,
    onClick
}: ITemplatePanelButtonProps) {
    if (!isShow) return;
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.TEMPLATE}
            title={TEMPLATE_SECTION_TITLE}
            onClick={() => {
                setSubTab(EBoardSetting.TEMPLATE);
                onClick();
            }}
        />
    );
}
